// Document type order configuration
export const DOCUMENT_TYPE_ORDER = [
  "Licenses & company structure",
  "Compliance/insurances", 
  "Financial documents",
  "Experience",
  "Operational capacity"
];

// Status configuration
export const STATUS_CONFIG = {
  rejected: { color: "#EF4444", bgcolor: "#FEF2F2", label: "Rejected" },
  pending: { color: "#F59E0B", bgcolor: "#FFFBEB", label: "Pending" },
  submitted: { color: "#3B82F6", bgcolor: "#EFF6FF", label: "Submitted" },
  approved: { color: "#10B981", bgcolor: "#ECFDF5", label: "Approved" }
};

// Convert API data to grouped format
export const convertDocumentData = (apiData) => {
  if (!apiData || !Array.isArray(apiData)) {
    return [];
  }

  const groupedData = new Map();

  apiData.forEach((doc) => {
    const type = doc.type || "Unknown Type";
    const sub_data = doc.sub_type || "Unknown Subtype";

    if (!groupedData.has(type)) {
      groupedData.set(type, []);
    }

    groupedData.get(type).push({
      id: doc.id,
      name: sub_data,
      doc_type_id: doc.doc_type_id,
      ...doc,
    });
  });

  // Convert to array and sort by the defined order
  const documentData = Array.from(groupedData, ([type, sub_data]) => ({
    type,
    sub_data,
  }))
  .sort((a, b) => {
    const indexA = DOCUMENT_TYPE_ORDER.indexOf(a.type);
    const indexB = DOCUMENT_TYPE_ORDER.indexOf(b.type);
    
    // If both types are in the order array, sort by their position
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    // If only one is in the order array, prioritize it
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    // If neither is in the order array, maintain original order
    return 0;
  });

  return documentData;
};

// Determine verification status
export const renderVerificationStatus = (doc) => {
  if (doc?.is_verified) {
    return "approved";
  } else if (!doc?.is_verified && !doc?.url) {
    return "pending";
  } else if (!doc?.is_verified && doc?.url && doc?.status !== "REJECTED") {
    return "submitted";
  } else {
    return "rejected";
  }
};

// Download document utility
export const downloadDocument = (doc) => {
  if (doc?.url) {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = doc.url;
    link.download = doc.sub_type || 'document';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Create file input for upload
export const createFileInput = (onFileChange) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.pdf,.zip';
  input.onchange = onFileChange;
  return input;
};
